<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { getCates } from '@/utils/service'

export default {
  created() {
    getCates()
  },
  name: 'app'
}
</script>

<style lang="less">
body, html, div {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
#app {
  font-family: Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,\\5FAE\8F6F\96C5\9ED1,Arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.flex-row-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.flex-row-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.flex-row-around {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.flex-row-start {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.flex-row-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.flex-column-between {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.flex-column-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.mini-button {
  width: 36px !important;
  height: 20px !important;
  line-height: 20px !important;
  text-algin: center !important;
  font-size: 12px !important;
  padding: 0 !important
}
.myRow {
  margin-bottom: 16px;
}
.myth {
  text-align: center !important;
  background: #eef1f6 !important;
  font-weight: 700 !important;
  color: #333;
}
.mytd {
  text-align: center !important;
  padding: 8px !important;
}
.profile div {
  border: none !important;
}
.profilesub {
  text-align: right;
}
.profilesub li, .profilesub ul {
  width: 200px;
  margin: 0 !important;
}
</style>
